import $ from 'jquery';

const AddBookWidget = (() => {
  const addBook = function (item) {
    const element = item;
    const $select = element.find('.js__address-book-select');

    $select.each((i, selectElement) => {
      const $selectElement = $(selectElement);
      const $formWrapper = $selectElement.closest('.js__address-book-wrapper');

      $selectElement.dropdown({
        forceSelection: true,

        onChange: function (name, text, choice) {
          $.each($formWrapper.find('input, select'), (key, input) => {
            const $input = $(input);
            const $selectText = $input.siblings('.text');

            if (!$input.hasClass('js__ignore-autofill')) {
              $input.val('');
              if ($input.is('select') && $selectText) {
                $selectText.text('');
              }
            }
          });

          handleAddressData(choice, $formWrapper);
        },
      });
    });
  };

  const handleAddressData = (choice, element) => {
    $.each(choice.data(), (property, value) => {
      const field = findByName(element, property);

      if (property.indexOf('town') !== -1) {
        field.val(value).change();
      } else {
        field.val(value);
      }
    });
  };

  const parseKey = key => {
    return key.replace(/(_\w)/g, words => {
      return words[1].toUpperCase();
    });
  };

  const findByName = (element, name) => {
    return element.find(`[name*='${parseKey(name)}']`);
  };

  return {
    addBook: addBook,
  };
})();

export default AddBookWidget;
